import { useEffect } from 'react';
import apis from './apis';
import useRequest from '../../utils/request';

export default (function (line_id) {
  const { data, exec } = useRequest({ url: '', name: apis.getLine.name, manual: true });

  useEffect(() => {
    if (line_id) {
      let url = `${apis.getLine.url}?line_id=${line_id}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line_id]);

  return data || {};
});
